// extracted by mini-css-extract-plugin
module.exports = {"c-label":"invitationLink_c-label__2EJcW","c-button":"invitationLink_c-button__2XFhj"};